<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-col :xs="8" :sm="8" :lg="8">
      <el-button type="normal" @click.prevent="goBack" class="ml-20" circle>
        <i class="el-icon-d-arrow-left"></i>
      </el-button>
    </el-col>
    <el-col :xs="16" :sm="16" :lg="16" class="text-right">
      <el-button v-if="job.jobInfo.alreadySigned === 'no'" type="primary" @click.prevent="handleSign" class="mr-20">簽核 <i
          class="el-icon-s-claim"></i></el-button>
      <el-tag v-if="job.jobInfo.alreadySigned === 'yes'" type="warning" class="mr-20">已簽核</el-tag>
    </el-col>

    <!--    基本資料-->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
          </div>
          <div>
            <el-form class="myform"　>
              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="人員：">
                    {{job.todoInfo.userObj.username}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題：">
                    {{job.todoInfo.title}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期：">
                    {{job.todoInfo.startDate | fmtDate}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="內部管理報告：">
                    <br/>
                    <div v-html="job.todoInfo.htmlNotes" class="mynotes"></div>
                    
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-main>
    </el-col>

    <!-- 工作項目資料 -->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="taskMain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>工作項目資料</span>
          </div>
          <div>

            
            <el-table :data="job.divMgrHistory" empty-text="無資料" stripe :default-expand-all="true">
              <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="項目" prop="taskTypeName">
                </el-table-column>
                <el-table-column label="" type="expand" >
                  <template slot-scope="scope">
                  <p class="mt-10 ml-10">
                    內容 : <br/>
                    <div v-html="fmtNotes(scope.row.notes)" class="mynotes ml-10 mt-10"></div>
                    
                  </p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>
                  </li>
                </ol>
                </template>
              </el-table-column>
            </el-table>


          </div>
        </el-card>
      </el-main>
    </el-col>

    <!-- 現有客戶拜訪資料 -->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="taskMain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <!-- <span>現有客戶拜訪紀錄 {{job.customerHistory.length}} 間</span> -->
            <span>現有客戶拜訪紀錄</span>
          </div>
          <div>
            <el-table :data="job.customerHistory" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="客戶" prop="customer.company">
                </el-table-column>
                <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p class="mt-10 ml-10">聯絡人: {{scope.row.customer.name}}</p>
                  <p class="mt-10 ml-10">抵達時間: {{scope.row.arrivalTime}}</p>
                  <p class="mt-10 ml-10 line15">紀錄/回饋: {{scope.row.notes}}</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                  </li>
                </ol>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>

    <!-- 新客戶拜訪資料 -->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="taskMain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <!-- <span>新客戶拜訪紀錄，共 {{job.newCustomerHistory.length}} 間</span> -->
            <span>新客戶拜訪紀錄</span>
          </div>
          <div>
            <el-table :data="job.newCustomerHistory" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="客戶" prop="customer.company">
                </el-table-column>
                <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p class="mt-10 ml-10">聯絡人: {{scope.row.customer.name}}</p>
                  <p class="mt-10 ml-10">抵達時間: {{scope.row.arrivalTime}}</p>
                  <p class="mt-10 ml-10 line15">紀錄/回饋: {{scope.row.notes}}</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>
                  </li>
                </ol>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-col>


    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div style="padding:20px">
              <div class="mb-20">今日哩程紀錄</div>
              <br/>
              <el-radio readonly :disabled="true" v-model="job.todoInfo.hasMile" label="N">無</el-radio>
              <el-radio readonly :disabled="true" v-model="job.todoInfo.hasMile" label="Y">有</el-radio>
            </div>
          </el-card>
        </el-main>
      </el-col>
    <el-col :xs="24" :sm="24" :lg="24" v-if="job.todoInfo.hasMile === 'Y'">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>交通工具與里程數</span>
            </div>
            <div>
              <el-table :data="job.drivingHistory" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="交通工具" prop="carType">
                </el-table-column>
                <el-table-column label="" type="expand" >
                  <template slot-scope="scope">
                    <p class="mt-10 ml-10">哩程: {{scope.row.startMile}}~{{scope.row.endMile}}</p>
                    <ol class="ml-10">
                      <li v-for="f in scope.row.fileListDisplay" :key="f.id" >
                        <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                        <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>
                      </li>
                    </ol>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-main>
      </el-col>

    <el-col :xs="24" :sm="24" :lg="24" v-if="job.jobInfo.status !== 'draft'" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>

            <el-table :data="job.signoffHistory" empty-text="無資料" stripe :default-expand-all="true">
              <el-table-column label="時間" prop="updatedAt" width="170">
                <template slot-scope="scope">
                  <p>簽核時間 :</p>
                  <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                  <p class="mt-10">{{ scope.row.signerObj.username }}</p>
                </template>
              </el-table-column>
              <el-table-column label="結果" prop="signResult">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.signResult === 'N'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                  <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="" type="expand" width="30">
                  <template slot-scope="scope">
                    <p class="mt-10 ml-10">簽核備註 : {{ scope.row.notes }}</p>
                  </template>
                </el-table-column>

                <el-table-column>
                </el-table-column>
            </el-table>

          </div>
        </el-card>
      </el-main>
    </el-col>

  

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="簽核資訊"
               :visible.sync="signoff.dialog"
               :width="dw">

      <el-form :model="job.jobInfo" ref="signForm" :rules="signoff.rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="簽核選擇" prop="signResult">
              <el-radio v-model="job.jobInfo.signResult" label="Y">同意</el-radio>
              <el-radio v-model="job.jobInfo.signResult" label="N">退回</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="備註" prop="notes">
              <el-input rows="5" type="textarea" v-model="job.jobInfo.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="signoff.dialog = false">取 消</el-button>
        <el-button type="primary" @click="sendSignoff('signForm')">確 定</el-button>
      </div>
    </el-dialog>

    <!-- 附件圖-->
<el-dialog title="附件圖"
           :visible.sync="img.dialog"
           :width="dw">
    <div class="demo-image">
      <el-image
        style="width: 100%; max-width: 100%; height: 100%;"
        :src="img.url"
        fit="cover" lazy>
          <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
        </el-image>
    </div>
 </el-dialog>

   
  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";

export default {
  name: "TodoDetailDivMgrReview",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
        if (value === '' || value === null) {
          callback(new Error('請輸入資料'))
        } else {
          callback()
        }
      }
      let checkRadio = (rule, value, callback) => {
        console.log("checkRadio:", rule, value)
        if (value === '' || value === null) {
          callback(new Error('請選擇同意或退回'))
        } else {
          callback()
        }
      }

    return {
      img:{
        dialog: false,
        url:''
      },
      dw: '50%',
      signoff:{
        dialog: false,
        notes: '',
        rules: {
          signResult: [{required: true, validator: checkRadio, trigger: 'change'}]
          // notes: [{required: true, validator: checkName, trigger: 'change'}]
        }
      },
      job:{
        id:'',
        jobInfo:{
          id:'',
          alreadySigned:'no'
        },
        todoInfo:{
          userObj:{},
          htmlNotes:''
        },
        divMgrHistory:[],
        customerHistory:[],
        signoffHistory:[],
        drivingHistory:[],
        newCustomerHistory:[]
      },
    }
    
  },
  methods:{
    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    findJobContent() {
      this.request.get("/job/detail/" + this.job.id).then(res => {
        if (res.code === '200') {
          this.job = res.data
          this.job.todoInfo.htmlNotes = this.fmtNotes(this.job.todoInfo.notes)
        }
      })
    },
    goBack() {
      this.$router.push('/message/my-signoff')
    },
    handleSign() {
      this.signoff.dialog = true
      this.signoff.notes = ''

    },
    sendSignoff(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.request.post("/job", this.job.jobInfo).then(res => {
            if (res.code === '200') {
              this.showResult('success', '完成簽核')
              this.signoff.dialog = false
              this.$router.push('/message/my-signoff')
            } else {
              this.showResult('error', '簽核結果儲存失敗')
            }
          })
        }
      })
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = '400' // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = '90%'
      } else {
        this.dw = '50%'
      }
    }
    
    
  },
  mounted(){
    this.job.id = this.$route.params.jobId
    // console.log("this.form.id:", this.job.id)

    this.findJobContent()
    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.myform >>> .el-form-item__label {
  padding: 0;
}

.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0 4px;
}
.el-table {
  padding: 0;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-autocomplete {
  width: 100%;
}
.el-card__body {
  padding: 20px 0 !important;
}
.mynotes  {
  line-height: 25px;
  font-size: 16px;
}

</style>
